export const LogoutIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1348 10.3C16.0951 10.3961 16.0378 10.4828 15.9657 10.5549L10.7413 15.7792C10.5888 15.9318 10.3881 16.0091 10.1875 16.0091C9.98689 16.0091 9.78624 15.9328 9.63369 15.7792C9.32754 15.4731 9.32754 14.9767 9.63369 14.6706L13.5206 10.7837H0.783654C0.351077 10.7837 0 10.4326 0 10C0 9.56745 0.351077 9.21637 0.783654 9.21637H13.5196L9.63267 5.32948C9.32652 5.02333 9.32652 4.52698 9.63267 4.22084C9.93881 3.91469 10.4352 3.91469 10.7413 4.22084L15.9657 9.4452C16.0378 9.51729 16.0951 9.60391 16.1348 9.70004C16.2142 9.89229 16.2142 10.1078 16.1348 10.3ZM19.5913 2.94714C19.1588 2.94714 18.8077 3.29822 18.8077 3.7308V16.2693C18.8077 16.7018 19.1588 17.0529 19.5913 17.0529C20.0239 17.0529 20.375 16.7018 20.375 16.2693V3.7308C20.375 3.29822 20.0239 2.94714 19.5913 2.94714Z"
        fill="#7A7A7A"
      />
    </svg>
  );
};
